
import { Product } from "@/lib/types";
import { 
  MigrationSection, 
  AlertsSection, 
  UsageSection, 
  StatsSection,
  TodaysRegistrations
} from "./sections";

interface DashboardContentProps {
  products: Product[];
  lowStockProducts: Product[];
  dismissedAlerts: string[];
  showMigration: boolean;
  isMigrating: boolean;
  onDismissAlert: (productId: string) => void;
  onAddStock: (product: Product) => void;
  onUsageRecorded: () => void;
  onMigrateData: () => void;
}

const DashboardContent = ({
  products,
  lowStockProducts,
  dismissedAlerts,
  showMigration,
  isMigrating,
  onDismissAlert,
  onAddStock,
  onUsageRecorded,
  onMigrateData
}: DashboardContentProps) => {
  return (
    <main className="page-container">
      <TodaysRegistrations />
      
      <MigrationSection 
        showMigration={showMigration}
        isMigrating={isMigrating}
        onMigrateData={onMigrateData}
      />
      
      <AlertsSection 
        lowStockProducts={lowStockProducts}
        onDismissAlert={onDismissAlert}
        onAddStock={onAddStock}
      />
      
      <UsageSection 
        onUsageRecorded={onUsageRecorded}
      />
      
      <StatsSection 
        products={products}
        lowStockProducts={lowStockProducts}
      />
    </main>
  );
};

export default DashboardContent;
